module.exports = __webpack_public_path__ + "static/media/ODS.9aa23993.png";